export const limitationsDictionnary = [
  {
    text: '',
    key: 'password-confirm/at-least-one-big-cap-in-password',
    code: 'password_has_uppercase',
  },
  {
    text: '',
    key: 'password-confirm/at-least-one-small-cap-in-password',
    code: 'password_has_lowercase',
  },
  {
    text: '',
    key: 'password-confirm/at-least-one-number-in-password',
    code: 'password_has_number',
  },
  {
    text: '',
    key: 'password-confirm/min-special-characters',
    code: 'password_nmin_special_characters',
  },
  {
    text: '',
    key: 'password-confirm/min-characters',
    code: 'password_nmin_characters',
  },
];
